import { getVisibleFieldError, useField } from '@ff-it/form';
import { Alert } from '@ff-it/ui';
import { ReactElement } from 'react';

const subscription = {
  submitError: true,
  dirtySinceLastSubmit: true,
  error: true,
  dirty: true,
  touched: true,
};
export function FormInlineError({ name, className }: { name: string; className?: string }): ReactElement | null {
  const { meta } = useField(name, { subscription });
  const err = getVisibleFieldError(meta);

  if (err && typeof err[0] === 'string') {
    return (
      <Alert variant="danger" className={className} mb="3">
        {err}
      </Alert>
    );
  }

  return null;
}
/**
 * @deprecated do we ever want this? We don't have a place to render this in table
 * ! We DO want this having error on particular member is helpful
 * */
export function FormInlineMemberError({ name, className }: { name: string; className?: string }): ReactElement | null {
  const { meta } = useField(name, { subscription });
  // Member errors are structured objects at runtime, despite the SDK's string error type.
  const err = getVisibleFieldError(meta) as unknown as { non_field_errors?: string } | undefined;

  if (err && err.non_field_errors) {
    return (
      <Alert variant="danger" className={className} mb="3">
        {err.non_field_errors}
      </Alert>
    );
  }

  return null;
}
